export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const DEL_ACCESS_TOKEN = "DEL_ACCESS_TOKEN";
export const SET_USER_INFO = "SET_USER_INFO";
export const DEL_USER_INFO = "DEL_USER_INFO";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_PERMISSION = "SET_PERMISSION";
export const SET_QA_TERM = "SET_QA_TERM";
